import en from './en'

// Spanish (Mexico). English is used as a fallback for keys that have not yet
// been localized, so this locale always stays compatible with the base locale.
export default {
  ...en,
  common: {
    ...en.common,
    title: 'Sistema de afiliados',
    logout: 'Cerrar sesión',
    changePassword: 'Cambiar contraseña',
    login: 'Iniciar sesión',
    signup: 'Registrarse',
    username: 'Usuario',
    loginnow: 'Iniciar sesión ahora',
    password: 'Contraseña',
    apply: 'Solicitar',
    verificationcode: 'Código de verificación',
    verification_title: 'Verificación de seguridad, haz clic siguiendo los pasos:',
    verification_drag_title: 'Verificación de seguridad, arrastra para verificar',
    verify_success: 'Verificación exitosa',
    refresh: 'Actualizar',
    submit: 'Enviar',
    register_affi: 'Regístrate ahora',
    back_login: 'Volver al inicio de sesión',
    contact_us: 'Contáctanos',
    affiliateaccountcanonlycontainnumchar:
      'La cuenta de afiliado solo puede contener guiones bajos (_), números y letras.',
    confirmpassword: 'Confirmar contraseña',
    affiliateaccount: 'Nombre de la cuenta de afiliado',
    forgetpass: 'Olvidé mi contraseña',
    zhuanshukefufuwu: 'Servicio al cliente exclusivo',
    askus: 'Solicitar',
    download: 'Descargar',
    copy: 'Copiar',
    copied: 'Copiado',
    email: 'Correo electrónico',
  },
  depositStatus: {
    ...en.depositStatus,
    SUCCESS: 'Exitoso',
    SUPPLEMENT_SUCCESS: 'Complemento exitoso',
    CLOSED: 'Cerrado',
    PENDING: 'Pendiente',
  },
  withdrawStatus: {
    ...en.withdrawStatus,
    ALL: 'Todos',
    SUCCESS: 'Exitoso',
    FAIL: 'Fallido',
    APPLY: 'En proceso',
    STEP_1: 'En revisión',
    STEP_2: 'Pendiente de pago',
    STEP_3: 'Pago en proceso',
    AUTOPAY: 'Pago automático',
    PENDING: 'Suspendido',
    REJECT: 'Rechazado',
    SENDING: 'Enviando',
    WAITING_CALLBACK: 'Esperando confirmación',
    PAYING: 'Pagando',
    WAITING_AUTO_PAY: 'Esperando pago automático',
    FAIL_REVIEW: 'Revisión fallida',
  },
  questions: {
    mothersName: '¿Cuál es el nombre de tu madre?',
    mothersBirthday: '¿Cuándo es el cumpleaños de tu madre?',
    dadsName: '¿Cuál es el nombre de tu padre?',
    dadsBirthday: '¿Cuándo es el cumpleaños de tu padre?',
    spouseBirthday: '¿Cuándo es el cumpleaños de tu pareja?',
    cityBorn: '¿En qué ciudad naciste?',
    highSchool: '¿A qué preparatoria asististe?',
    elementarySchool: '¿Cómo se llamaba tu escuela primaria?',
    firstPetName: '¿Cómo se llamaba tu primera mascota?',
    firstCar: '¿Cuál fue la marca de tu primer auto?',
  },
  fields: {
    onlineCustomerService: 'Servicio al cliente en línea',
    ...en.fields,
    filters: 'Filtros',
    account: 'Cuenta',
    accountInfo: 'Información de la cuenta',
    activeMember: 'Miembro activo',
    activePlayer: 'Jugador activo',
    activeUsers: 'Usuarios activos',
    add: 'Agregar',
    adjust: 'Ajustar',
    affiliate: 'Afiliado',
    affiliateAccount: 'Cuenta de afiliado',
    affiliateCode: 'Código de afiliado',
    affiliateInfo: 'Información del afiliado',
    affiliateLevel: 'Nivel de afiliado',
    affiliateStatus: 'Estado del afiliado',
    amount: 'Monto',
    balance: 'Saldo',
    bank: 'Banco',
    bankCard: 'Tarjeta bancaria',
    bankName: 'Nombre del banco',
    bet: 'Apuesta',
    betRecord: 'Registro de apuestas',
    bind: 'Vincular',
    bonus: 'Bono',
    cancel: 'Cancelar',
    cardNumber: 'Número de tarjeta',
    ewalletNumberHint: 'Ingrese un número que comience con 0',
    commission: 'Comisión',
    commissionBalance: 'Saldo de comisiones',
    commissionRate: 'Tasa de comisión',
    confirm: 'Confirmar',
    copy: 'Copiar',
    createTime: 'Fecha de creación',
    currentPassword: 'Contraseña actual',
    deposit: 'Depósito',
    depositAmount: 'Monto del depósito',
    depositDate: 'Fecha del depósito',
    depositRecord: 'Registro de depósitos',
    download: 'Descargar',
    edit: 'Editar',
    email: 'Correo electrónico',
    endDate: 'Fecha de finalización',
    enquire: 'Consultar',
    finishDate: 'Fecha de conclusión',
    gameName: 'Nombre del juego',
    gameType: 'Tipo de juego',
    lastLoginTime: 'Último inicio de sesión',
    link: 'Enlace de invitación',
    loginName: 'Usuario',
    loginPassword: 'Contraseña',
    member: 'Miembro',
    month: 'Mes',
    myAccount: 'Mi cuenta',
    name: 'Nombre',
    newPassword: 'Nueva contraseña',
    noData: 'Sin datos',
    actions: 'Acciones',
    operate: 'Operación',
    password: 'Contraseña',
    paymentMethod: 'Método de pago',
    platform: 'Plataforma',
    profit: 'Ganancia',
    realName: 'Nombre completo',
    recordTime: 'Fecha de registro',
    referralCode: 'Código de referido',
    referralLink: 'Enlace de referido',
    registerTime: 'Fecha de registro',
    reset: 'Restablecer',
    result: 'Resultado',
    search: 'Buscar',
    select: 'Seleccionar',
    serialNumber: 'Número de serie',
    startDate: 'Fecha de inicio',
    status: 'Estado',
    submit: 'Enviar',
    telephone: 'Teléfono',
    title: 'Título',
    today: 'Hoy',
    total: 'Total',
    transfer: 'Transferir',
    withdraw: 'Retirar',
    withdrawAmount: 'Monto del retiro',
    english: 'Inglés',
    chinese: 'Chino',
    mexicanSpanish: 'Español (México)',
  },
  forgetPassword: {
    ...en.forgetPassword,
    verifyAuth: 'Autenticación',
    verifyQues: 'Pregunta de seguridad',
    resetPassword: 'Restablecer contraseña',
    verify: 'Verificar',
    submit: 'Enviar',
    reset: 'Restablecer',
    answer: 'Respuesta',
    messageAuth: 'Ingresa tu usuario y el código de Google Authenticator',
    messageQues: 'Responde la siguiente pregunta de seguridad',
    messageReset: 'Restablece tu contraseña',
    noSecurityQuestionSet:
      'Esta cuenta no tiene una pregunta de seguridad configurada. Contacta a soporte.',
    resetSuccess: 'Contraseña restablecida correctamente',
  },
  message: {
    ...en.message,
    adjustSuccess: 'Ajuste exitoso',
    addSuccess: 'Agregado correctamente',
    bindBankCard: 'Primero vincula una tarjeta bancaria',
    deleteSuccess: 'Eliminado correctamente',
    editSuccess: 'Actualizado correctamente',
    emailFormat: 'Ingresa un correo electrónico válido',
    inputDigits: 'Ingresa solo números',
    inputPassword: 'Ingresa la contraseña',
    inputPasswordAgain: 'Ingresa nuevamente la contraseña',
    reenterPassword: 'Vuelve a ingresar la contraseña',
    requiredAmount: 'El monto es obligatorio',
    requiredEmail: 'El correo electrónico es obligatorio',
    requiredLoginName: 'El usuario es obligatorio',
    requiredPassword: 'La contraseña es obligatoria',
    requiredTelephone: 'El teléfono es obligatorio',
    requiredEwallet: 'Ingrese el número de e-Wallet',
    success: 'Éxito',
    twoPasswordNotMatch: 'Las contraseñas no coinciden',
    validateNumberOnly: 'Ingresa solo números',
    validateEwallet: 'Solo se aceptan números para el e-Wallet',
    understand: 'Entendido',
    confirmDelete: '¿Confirmas que deseas eliminar estos datos? Esta acción no se puede deshacer.',
  },
  menu: {
    ...en.menu,
    Dashboard: 'Panel',
    'Downline Info': 'Información de la red',
    Member: 'Miembros',
    Affiliate: 'Afiliados',
    AffiliateSummary: 'Resumen de afiliados',
    gameRecord: 'Registro de juegos',
    financeCentre: 'Centro financiero',
    'Bet Record': 'Registro de apuestas',
    'Deposit Record': 'Registro de depósitos',
    Statistics: 'Estadísticas',
    'Game Stats': 'Estadísticas de juegos',
    'Affiliate Center': 'Centro de afiliados',
    Deposit: 'Depósito',
    'Bind Bank Cards': 'Vincular tarjetas bancarias',
    'Bank Withdrawal': 'Retiro bancario',
    Transfer: 'Transferencia',
    'Referral Centre': 'Centro de referidos',
    'Referral Management': 'Administración de referidos',
    'Referral Link': 'Enlace de referido',
    'Personal Center': 'Centro personal',
    'Settlement Center': 'Centro de liquidaciones',
    'Finance Report': 'Reporte financiero',
    'Settlement Report': 'Reporte de liquidaciones',
    contactUs: 'Contáctanos',
    Withdraw: 'Retiro',
    'Rebate Report': 'Reporte de reembolsos',
  },
}
